export const cohortBuilderViewCardMessagesEn = {
  // Cohort Builder - View Card
  'projects.cohortBuilder.cohortBuilderItemViewCard.inUse': 'Used by:',
  'projects.cohortBuilder.cohortBuilderItemViewCard.notInUse': 'This item is not being used',
  'projects.cohortBuilder.cohortBuilderItemViewCard.deleteInUse':
    'Please remove all references to this item before deleting.',
  'projects.cohortBuilder.cohortBuilderItemViewCard.deleteNotInUse': 'Delete',
};
